<template>
  <v-container class="toggle animated" fluid>
    <v-row dense>
      <!-- First card -->
      <v-col cols="12" xl="8" md="7">
        <v-card elevation="5" :loading="loading">
          <v-card-title class="text-subtitle-1 font-weight-bold">
            <v-icon color="green">mdi-bell-ring</v-icon>
            Academic Unit Management System Announcements
            <v-divider class="my-2"></v-divider>
          </v-card-title>
          <v-card-text>
            <v-row class="d-flex justify-center align-start" style="min-height: 200px;">
              <v-col cols="12">
                <v-card elevation="0">
                  <v-card-text class="font-weight-bold text-body-1" style="white-space: pre-wrap;">
                    <p v-if="announcementData && announcementData.details">
                      {{ announcementData.details }}
                    </p>
                    <p v-else>
                      No announcement as of now.
                    </p>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Deadlines Carousel -->
      <v-col cols="12" xl="4" md="5">
        <v-card elevation="5" :loading="loading">
          <v-card-title class="text-subtitle-1 font-weight-bold">
            <v-icon color="green">mdi-calendar-check</v-icon>
            Deadlines of Submissions
            <v-divider class="my-2"></v-divider>
          </v-card-title>
          <v-card-text v-if="scheduleData.length == 0">
              <v-card elevation="0" class="d-flex justify-center align-center" height="176">
                <div class="fsont-wieght-bold text-h6">No Schedule Created</div>
              </v-card>
          </v-card-text>
          <v-card-text v-else>
            <v-carousel v-model="carouselIndex" height="175" show-arrows :cycle="true" :continuous="true" size="small" hide-delimiters>
              <template v-slot:prev="{ props }">
                <v-btn v-bind="props" variant="text" class="custom-arrow"></v-btn>
              </template>
              <template v-slot:next="{ props }">
                <v-btn v-bind="props" variant="text" class="custom-arrow"></v-btn>
              </template>
              <v-carousel-item v-for="(schedule, index) in scheduleData" :key="index">
                <v-card elevation="0" class="d-flex align-center justify-center" height="175">
                  <v-card-text class="d-flex flex-column justify-center align-center text-center w-100 ga-2">
                    <div class="font-weight-bold text-h6 text-truncate w-75">
                      {{ schedule.compliance.compliance_name }} 
                      <span v-if="schedule.compliance.is_term_separated">({{ schedule.term.name }})</span>
                    </div>
                    <div>
                      <div class="font-weight-bold">Deadline</div>
                      <div class="text-body-2">{{ formatDate(schedule.deadline) }}</div>
                    </div>
                    <div v-if="schedule.is_extended">
                      <div class="font-weight-bold">Deadline Extension</div>
                      <div class="text-body-2">{{ formatDate(schedule.deadline_extension) }}</div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-carousel-item>
            </v-carousel>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Subject Load Card with Sparkline -->
      <v-col cols="12">
        <v-card elevation="5" :loading="loading">
          <v-card-title class="text-subtitle-1 font-weight-bold">
            <v-icon color="green">mdi-clipboard-list-outline</v-icon>
               Submissions
            <v-divider class="my-2"></v-divider>
          </v-card-title>
          <v-card-text>
            <v-row class="d-flex justify-center align-center">
              <v-col cols="12">
                <v-sparkline
                  :model-value="trendData"
                  color="green"
                  stroke-linecap="round"
                  auto-draw
                  smooth
                ></v-sparkline>
                <div class="text-center text-body-2 font-weight-bold mt-2">Trends</div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Dashboard',
  data() {
    return {
      loading: false,
      scheduleData: [],
      announcementData: [],
      carouselIndex: 0,
      trendData: [10, 15, 12, 18, 20, 17, 19] // Sample data for subject load
    };
  },
  methods: {
    async init() {
      this.loading = true;
      const res = await this.axiosCall('/schedules/getAllBySemesterSchoolyear/' + this.$store.state.semester_schoolyear.id, 'get', null, true);
      if (res && res.data) {
        this.scheduleData = res.data;
      }
      const anouncement = await this.axiosCall('/announcements/findOneActive', 'get', null, true);
      if (anouncement && anouncement.data) {
        this.announcementData = anouncement.data;
      }
      this.loading = false;
    }
  },
  mounted() {
    this.init();
  }
});
</script>

<style scoped>
.custom-arrow {
  background-color: transparent !important;
  box-shadow: none !important;
  color: black !important; /* Change if needed */
}

::v-deep(.v-btn--icon) {
  background-color: transparent !important;
  box-shadow: none !important;
}
</style>
